import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import VConsole from 'vconsole';

// Initialize VConsole in development mode
if (process.env.NODE_ENV !== 'production') {
  new VConsole();
}

const routes = [
  { path: '/', component: () => import('./components/landing_page/Index.vue') },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

const app = createApp(App);

app.use(router);
app.mount('#app');